export default "__VITE_ASSET__DuWM7mqO__"